module.exports = __webpack_public_path__ + "static/media/Svarove.56df4a06.md";